import { Messages } from '~src/codegen/Localize';
import { RegexBasedPasswordPolicy } from './RegexBasedPasswordPolicy';

export class MustContainSymbolsPolicy extends RegexBasedPasswordPolicy {

    private static instance: MustContainSymbolsPolicy = new MustContainSymbolsPolicy();

    private constructor() {
        super(/[-!@$%^&*()_+|~=`{}\[\]:";'<>?,.\/#]/);
    }

    public static getPolicy(): MustContainSymbolsPolicy {
        return MustContainSymbolsPolicy.instance;
    }

    public getErrorMessage(): string {
        return Messages.passwordPolicies_mustContainSymbols();
    }

    public getTestId(): string {
        return MustContainSymbolsPolicy.name;
    }
}
